/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * GTO Wizard API v4
 * API documentation for GTO Wizard frontend API
 * OpenAPI spec version: 4
 */
import { useMutation } from '@tanstack/vue-query'
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationReturnType,
} from '@tanstack/vue-query'

import { unref } from 'vue'
import type { MaybeRef } from 'vue'

import type {
  ConfirmoPaymentResponse,
  CreateConfirmoOneTimePaymentRequest,
  CreateConfirmoOneTimePaymentResponse,
  CreateCreditsPaymentRequest,
  CreateSubscriptionRequest,
  ErrorResponse,
  InvoiceResponse,
  UpdateSubscriptionRequest,
} from '../models'

import createOneTimePaymentMutator from '../../../client'
import createSubscriptionMutator from '../../../client'
import webhookMutator from '../../../client'
import updateSubscriptionMutator from '../../../client'
import confirmoCreditsPaymentMutator from '../../../client'

type AwaitedInput<T> = PromiseLike<T> | T

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never

/**
 * @summary Create One Time Payment
 */
export const createOneTimePayment = (
  createConfirmoOneTimePaymentRequest: MaybeRef<CreateConfirmoOneTimePaymentRequest>,
  signal?: AbortSignal,
) => {
  createConfirmoOneTimePaymentRequest = unref(createConfirmoOneTimePaymentRequest)

  return createOneTimePaymentMutator<CreateConfirmoOneTimePaymentResponse>({
    url: `/v4/payments/confirmo/one-time-payment/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createConfirmoOneTimePaymentRequest,
    signal,
  })
}

export const getCreateOneTimePaymentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOneTimePayment>>,
    TError,
    { data: CreateConfirmoOneTimePaymentRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOneTimePayment>>,
  TError,
  { data: CreateConfirmoOneTimePaymentRequest },
  TContext
> => {
  const mutationKey = ['createOneTimePayment']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOneTimePayment>>,
    { data: CreateConfirmoOneTimePaymentRequest }
  > = props => {
    const { data } = props ?? {}

    return createOneTimePayment(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateOneTimePaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOneTimePayment>>
>
export type CreateOneTimePaymentMutationBody = CreateConfirmoOneTimePaymentRequest
export type CreateOneTimePaymentMutationError = unknown

/**
 * @summary Create One Time Payment
 */
export const useCreateOneTimePayment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOneTimePayment>>,
    TError,
    { data: CreateConfirmoOneTimePaymentRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof createOneTimePayment>>,
  TError,
  { data: CreateConfirmoOneTimePaymentRequest },
  TContext
> => {
  const mutationOptions = getCreateOneTimePaymentMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Create Subscription
 */
export const createSubscription = (
  createSubscriptionRequest: MaybeRef<CreateSubscriptionRequest>,
  signal?: AbortSignal,
) => {
  createSubscriptionRequest = unref(createSubscriptionRequest)

  return createSubscriptionMutator<ConfirmoPaymentResponse>({
    url: `/v4/payments/confirmo/subscription/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createSubscriptionRequest,
    signal,
  })
}

export const getCreateSubscriptionMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSubscription>>,
    TError,
    { data: CreateSubscriptionRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSubscription>>,
  TError,
  { data: CreateSubscriptionRequest },
  TContext
> => {
  const mutationKey = ['createSubscription']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSubscription>>,
    { data: CreateSubscriptionRequest }
  > = props => {
    const { data } = props ?? {}

    return createSubscription(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type CreateSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSubscription>>
>
export type CreateSubscriptionMutationBody = CreateSubscriptionRequest
export type CreateSubscriptionMutationError = ErrorResponse

/**
 * @summary Create Subscription
 */
export const useCreateSubscription = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSubscription>>,
    TError,
    { data: CreateSubscriptionRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof createSubscription>>,
  TError,
  { data: CreateSubscriptionRequest },
  TContext
> => {
  const mutationOptions = getCreateSubscriptionMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Webhook
 */
export const webhook = (invoiceResponse: MaybeRef<InvoiceResponse>, signal?: AbortSignal) => {
  invoiceResponse = unref(invoiceResponse)

  return webhookMutator<void>({
    url: `/v4/payments/confirmo/webhook/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: invoiceResponse,
    signal,
  })
}

export const getWebhookMutationOptions = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof webhook>>,
    TError,
    { data: InvoiceResponse },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof webhook>>,
  TError,
  { data: InvoiceResponse },
  TContext
> => {
  const mutationKey = ['webhook']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof webhook>>,
    { data: InvoiceResponse }
  > = props => {
    const { data } = props ?? {}

    return webhook(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type WebhookMutationResult = NonNullable<Awaited<ReturnType<typeof webhook>>>
export type WebhookMutationBody = InvoiceResponse
export type WebhookMutationError = ErrorResponse

/**
 * @summary Webhook
 */
export const useWebhook = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof webhook>>,
    TError,
    { data: InvoiceResponse },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof webhook>>,
  TError,
  { data: InvoiceResponse },
  TContext
> => {
  const mutationOptions = getWebhookMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Update Subscription
 */
export const updateSubscription = (
  subscriptionId: MaybeRef<string>,
  updateSubscriptionRequest: MaybeRef<UpdateSubscriptionRequest>,
) => {
  subscriptionId = unref(subscriptionId)
  updateSubscriptionRequest = unref(updateSubscriptionRequest)

  return updateSubscriptionMutator<ConfirmoPaymentResponse>({
    url: `/v4/payments/confirmo/subscription/${subscriptionId}/`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateSubscriptionRequest,
  })
}

export const getUpdateSubscriptionMutationOptions = <
  TError = ErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSubscription>>,
    TError,
    { subscriptionId: string; data: UpdateSubscriptionRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSubscription>>,
  TError,
  { subscriptionId: string; data: UpdateSubscriptionRequest },
  TContext
> => {
  const mutationKey = ['updateSubscription']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSubscription>>,
    { subscriptionId: string; data: UpdateSubscriptionRequest }
  > = props => {
    const { subscriptionId, data } = props ?? {}

    return updateSubscription(subscriptionId, data)
  }

  return { mutationFn, ...mutationOptions }
}

export type UpdateSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSubscription>>
>
export type UpdateSubscriptionMutationBody = UpdateSubscriptionRequest
export type UpdateSubscriptionMutationError = ErrorResponse

/**
 * @summary Update Subscription
 */
export const useUpdateSubscription = <TError = ErrorResponse, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSubscription>>,
    TError,
    { subscriptionId: string; data: UpdateSubscriptionRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof updateSubscription>>,
  TError,
  { subscriptionId: string; data: UpdateSubscriptionRequest },
  TContext
> => {
  const mutationOptions = getUpdateSubscriptionMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Confirmo Credits Payment
 */
export const confirmoCreditsPayment = (
  createCreditsPaymentRequest: MaybeRef<CreateCreditsPaymentRequest>,
  signal?: AbortSignal,
) => {
  createCreditsPaymentRequest = unref(createCreditsPaymentRequest)

  return confirmoCreditsPaymentMutator<ConfirmoPaymentResponse>({
    url: `/v4/payments/confirmo/credits/`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createCreditsPaymentRequest,
    signal,
  })
}

export const getConfirmoCreditsPaymentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmoCreditsPayment>>,
    TError,
    { data: CreateCreditsPaymentRequest },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmoCreditsPayment>>,
  TError,
  { data: CreateCreditsPaymentRequest },
  TContext
> => {
  const mutationKey = ['confirmoCreditsPayment']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmoCreditsPayment>>,
    { data: CreateCreditsPaymentRequest }
  > = props => {
    const { data } = props ?? {}

    return confirmoCreditsPayment(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type ConfirmoCreditsPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmoCreditsPayment>>
>
export type ConfirmoCreditsPaymentMutationBody = CreateCreditsPaymentRequest
export type ConfirmoCreditsPaymentMutationError = unknown

/**
 * @summary Confirmo Credits Payment
 */
export const useConfirmoCreditsPayment = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmoCreditsPayment>>,
    TError,
    { data: CreateCreditsPaymentRequest },
    TContext
  >
}): UseMutationReturnType<
  Awaited<ReturnType<typeof confirmoCreditsPayment>>,
  TError,
  { data: CreateCreditsPaymentRequest },
  TContext
> => {
  const mutationOptions = getConfirmoCreditsPaymentMutationOptions(options)

  return useMutation(mutationOptions)
}
